import React, { useState } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { User, Mail, Phone, MapPin, Search, Filter, Users, BookOpen } from 'lucide-react';

const LecturingStaff = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('all');

  const lecturingStaff = [
    {
      id: 1,
      name: 'Öğr. Gör. Dr. Selin Koç',
      department: 'Matematik',
      email: 'selin.koc@hacettepe.edu.tr',
      phone: '+90 312 297 1111',
      office: 'Matematik Bölümü, Kat 1, Oda 105',
      courses: 'Genel Matematik, Matematik I-II',
      image: '/api/placeholder/150/200'
    },
    {
      id: 2,
      name: 'Öğr. Gör. Murat Kılıç',
      department: 'Fizik',
      email: 'murat.kilic@hacettepe.edu.tr',
      phone: '+90 312 297 2222',
      office: 'Fizik Bölümü, Kat 1, Oda 110',
      courses: 'Genel Fizik, Fizik Laboratuvarı',
      image: '/api/placeholder/150/200'
    },
    {
      id: 3,
      name: 'Öğr. Gör. Dr. Ayşe Polat',
      department: 'Kimya',
      email: 'ayse.polat@hacettepe.edu.tr',
      phone: '+90 312 297 3333',
      office: 'Kimya Bölümü, Kat 2, Oda 220',
      courses: 'Genel Kimya, Analitik Kimya',
      image: '/api/placeholder/150/200'
    },
    {
      id: 4,
      name: 'Öğr. Gör. Emre Yıldız',
      department: 'Biyoloji',
      email: 'emre.yildiz@hacettepe.edu.tr',
      phone: '+90 312 297 4444',
      office: 'Biyoloji Bölümü, Kat 1, Oda 115',
      courses: 'Genel Biyoloji, Botanik',
      image: '/api/placeholder/150/200'
    },
    {
      id: 5,
      name: 'Öğr. Gör. Dr. Nazlı Çelik',
      department: 'İstatistik',
      email: 'nazli.celik@hacettepe.edu.tr',
      phone: '+90 312 297 5555',
      office: 'İstatistik Bölümü, Kat 2, Oda 225',
      courses: 'Temel İstatistik, Olasılık',
      image: '/api/placeholder/150/200'
    },
    {
      id: 6,
      name: 'Öğr. Gör. Kemal Avcı',
      department: 'Bilgisayar Mühendisliği',
      email: 'kemal.avci@hacettepe.edu.tr',
      phone: '+90 312 297 6666',
      office: 'Bilgisayar Mühendisliği Bölümü, Kat 3, Oda 305',
      courses: 'Programlama Temelleri, Bilgisayar Laboratuvarı',
      image: '/api/placeholder/150/200'
    }
  ];

  const departments = ['Matematik', 'Fizik', 'Kimya', 'Biyoloji', 'İstatistik', 'Bilgisayar Mühendisliği'];

  const filteredStaff = lecturingStaff.filter(staff => {
    const matchesSearch = staff.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         staff.courses.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesDepartment = selectedDepartment === 'all' || staff.department === selectedDepartment;
    return matchesSearch && matchesDepartment;
  });

  return (
    <PageTemplate 
      title="Öğretim Görevlileri"
      breadcrumb={[
        { label: 'Anasayfa', url: '/' },
        { label: 'Fakülte Personeli', url: '/fakulte-personeli' },
        { label: 'Öğretim Görevlileri' }
      ]}
    >
      <div className="max-w-7xl mx-auto">
        {/* Başlık */}
        <div className="bg-gradient-to-br from-purple-50 to-violet-100 rounded-xl p-8 mb-8">
          <div className="flex items-center mb-4">
            <Users className="w-8 h-8 text-purple-600 mr-3" />
            <h2 className="text-2xl font-bold text-gray-800">Öğretim Görevlileri</h2>
          </div>
          <p className="text-gray-700">
            Fakültemizde görev yapan öğretim görevlilerinin iletişim bilgilerine ve verdikleri derslere buradan ulaşabilirsiniz.
          </p>
        </div>

        {/* Filtreler */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Arama */}
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Ad veya ders ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all"
              />
            </div>

            {/* Bölüm Filtresi */}
            <div className="relative">
              <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <select
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all appearance-none bg-white"
              >
                <option value="all">Tüm Bölümler</option>
                {departments.map(dept => (
                  <option key={dept} value={dept}>{dept}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Öğretim Görevlileri Kartları */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredStaff.map((staff) => (
            <div 
              key={staff.id}
              className="bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-lg transition-all duration-300 overflow-hidden"
            >
              <div className="p-6">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-100 to-violet-200 rounded-full flex items-center justify-center">
                    <User className="w-8 h-8 text-purple-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">{staff.name}</h3>
                    <p className="text-purple-600 font-medium">Öğretim Görevlisi</p>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center text-gray-600">
                    <BookOpen className="w-4 h-4 mr-2" />
                    <span className="text-sm">{staff.department}</span>
                  </div>
                  
                  <div className="flex items-start text-gray-600">
                    <Users className="w-4 h-4 mr-2 mt-0.5" />
                    <span className="text-sm">{staff.courses}</span>
                  </div>

                  <div className="flex items-center text-gray-600">
                    <Mail className="w-4 h-4 mr-2" />
                    <a 
                      href={`mailto:${staff.email}`}
                      className="text-sm hover:text-purple-600 transition-colors"
                    >
                      {staff.email}
                    </a>
                  </div>

                  <div className="flex items-center text-gray-600">
                    <Phone className="w-4 h-4 mr-2" />
                    <span className="text-sm">{staff.phone}</span>
                  </div>

                  <div className="flex items-start text-gray-600">
                    <MapPin className="w-4 h-4 mr-2 mt-0.5" />
                    <span className="text-sm">{staff.office}</span>
                  </div>
                </div>

                <div className="mt-4 pt-4 border-t border-gray-100">
                  <button className="w-full bg-purple-600 hover:bg-purple-700 text-white py-2 px-4 rounded-lg transition-colors text-sm font-medium">
                    İletişim Bilgileri
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Sonuç bulunamadı */}
        {filteredStaff.length === 0 && (
          <div className="text-center py-12">
            <User className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-600 mb-2">Öğretim görevlisi bulunamadı</h3>
            <p className="text-gray-500">
              Arama kriterlerinize uygun öğretim görevlisi bulunmamaktadır. Lütfen farklı terimler deneyin.
            </p>
          </div>
        )}
      </div>
    </PageTemplate>
  );
};

export default LecturingStaff; 